import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

export const agentApi = {
  async listAgents(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/agents', {
      headers: {
        ...withAuthHeaders(),
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
      },
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async createAgent(payload) {
    const response = await apiClient.post('/agents', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async updateAgent(agentId, payload) {
    const response = await apiClient.put(`/agents/${agentId}`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async deleteAgent(agentId) {
    const response = await apiClient.delete(`/agents/${agentId}`, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },
};

export function resolveAgentApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process agent request.');
}
